// extracted by mini-css-extract-plugin
export var closeButton = "_er-2";
export var closeButtonIcon = "_er-3";
export var lightboxContent = "_er-1";
export var lightboxOverlay = "_er-0";